/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import {
  isNil,
  has,
} from 'lodash';
import {
  injectIntl,
  FormattedMessage,
} from 'react-intl';
import styles from './styles.scss';


const defaultProps = {
  nul: 'empty',
  status: 'absent',
};

const propTypes = {
  status: React.PropTypes.string.isRequired,
  val: React.PropTypes.any,
  nul: React.PropTypes.any,
  formatter: React.PropTypes.func,
};

const kBuiltins = {
  empty: (
    <span className={styles.empty}>
      <FormattedMessage id="lora.emptyval" defaultMessage="Empty" />
    </span>
  ),
  loading: (
    <span className={styles.loading}>
      <i className="fa fa-spinner fa-spin" />
    </span>
  ),
};

class Nvl extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      val: props.val,
      status: props.status,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { val, status } = nextProps;
    if (val !== this.props.val) {
      this.setState({ val });
    }
    if (status !== this.props.status) {
      this.setState({ status });
    }
  }

  render() {
    const { status } = this.state;

    if (status === 'pending') {
      return kBuiltins.loading;
    }

    let { nul } = this.props;
    if (has(kBuiltins, nul)) {
      nul = kBuiltins[nul];
    }

    let { val } = this.state;
    if (isNil(val)) {
      return nul;
    }
    if (this.props.formatter) {
      val = this.props.formatter(val);
    }
    return <span>{val}</span>;
  }
}

Nvl.defaultProps = defaultProps;
Nvl.propTypes = propTypes;

export default injectIntl(Nvl);




// WEBPACK FOOTER //
// ./src/components/Nvl/index.jsx